import React from 'react';

export default function RefundPolicy() {
  return (
    <div
      style={{
        minHeight: '100vh',
        background:
          'linear-gradient(135deg, rgb(240 253 253) 0%, rgba(155, 222, 218, 0.73) 50%, rgb(3 186 187) 100%)',
        display: 'flex',
        justifyContent: 'center',
        padding: '50px 10px',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '15px',
          boxShadow: '0 6px 15px rgba(0,0,0,0.1)',
          width: '100%',
          maxWidth: '1100px',
          padding: '30px',
          boxSizing: 'border-box',
        }}
      >
        <h1
          style={{
            textAlign: 'center',
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '20px',
            color: '#0ccac3',
          }}
        >
          Refund & Cancellation Policy
        </h1>

        <h3 style={{ color: '#111827', marginBottom: '15px' }}>Introduction</h3>
        <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '20px' }}>
          This Refund and Cancellation Policy (“Policy”) applies to all users (“you” or “user”) of the website 
          <strong> www.gpsfinvest.com </strong> (“Website”), owned and operated by 
          <strong> GPS Finvest Private Limited </strong> (“GPS Finvest,” “we,” “us,” or “our”).
        </p>
        <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '20px' }}>
          By using our Website and services, you acknowledge and agree to this Policy. Please read it carefully before 
          making any purchase or availing of any service from us. We reserve the right to amend this Policy at any time 
          without prior notice. Changes will be effective immediately upon posting the revised Policy on the Website. 
          Your continued use of the Website after such changes constitutes your acceptance of the revised Policy.
        </p>

        {/* Section 1 */}
        <h4 style={{ color: '#111827', marginTop: '30px', marginBottom: '10px' }}>1. General Terms</h4>
        <ul style={{ color: '#4b5563', lineHeight: '1.8', marginLeft: '20px', listStyleType: 'disc' }}>
          <li>All purchases and payments made on our Website are final.</li>
          <li>GPS Finvest follows a no-refund and no-cancellation policy once a service has been purchased or payment has been successfully processed.</li>
          <li>By proceeding with a purchase, you confirm that you have carefully read and understood the details of the services being offered.</li>
        </ul>

        {/* Section 2 */}
        <h4 style={{ color: '#111827', marginTop: '30px', marginBottom: '10px' }}>2. No Refund Policy</h4>
        <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '10px' }}>
          Fees paid for services are non-refundable, regardless of whether you use the services fully, partially, or not at all.
          Refunds will not be provided under any circumstances, including but not limited to:
        </p>
        <ul style={{ color: '#4b5563', lineHeight: '1.8', marginLeft: '20px', listStyleType: 'disc' }}>
          <li>Change of mind after purchase.</li>
          <li>Dissatisfaction with services due to subjective reasons.</li>
          <li>Failure to use the services within the validity period.</li>
        </ul>
        <p style={{ color: '#4b5563', lineHeight: '1.8', marginTop: '10px' }}>
          We strongly recommend that users carefully review all service descriptions, terms, and eligibility requirements before making any payments.
        </p>

        {/* Section 3 */}
        <h4 style={{ color: '#111827', marginTop: '30px', marginBottom: '10px' }}>3. No Cancellation Policy</h4>
        <ul style={{ color: '#4b5563', lineHeight: '1.8', marginLeft: '20px', listStyleType: 'disc' }}>
          <li>Once a service or subscription has been purchased and payment is processed, cancellations are not permitted.</li>
          <li>Users are encouraged to ensure they have read all related policies, service descriptions, and conditions before proceeding with any transaction.</li>
        </ul>

        {/* Section 4 */}
        <h4 style={{ color: '#111827', marginTop: '30px', marginBottom: '10px' }}>4. Exceptions (If Any)</h4>
        <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '10px' }}>
          GPS Finvest does not generally offer refunds or cancellations. However, in rare cases where an error has occurred on our part 
          (such as duplicate payment deductions or technical issues during the transaction), we may, at our sole discretion, process a refund.
        </p>
        <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '10px' }}>
          Any such approved refund will be credited back to the original payment method within 7–10 working days, depending on the payment gateway and bank policies.
        </p>

        {/* Section 5 */}
        <h4 style={{ color: '#111827', marginTop: '30px', marginBottom: '10px' }}>5. Third-Party Payments</h4>
        <ul style={{ color: '#4b5563', lineHeight: '1.8', marginLeft: '20px', listStyleType: 'disc' }}>
          <li>Payments made through third-party payment processors (such as Razorpay, banks, or UPI platforms) are also subject to their respective terms and conditions.</li>
          <li>GPS Finvest shall not be responsible for delays, errors, or failures caused by third-party service providers.</li>
        </ul>

        {/* Section 6 */}
        <h4 style={{ color: '#111827', marginTop: '30px', marginBottom: '10px' }}>6. User Responsibility</h4>
        <ul style={{ color: '#4b5563', lineHeight: '1.8', marginLeft: '20px', listStyleType: 'disc' }}>
          <li>Reviewing the description of services offered before payment.</li>
          <li>Reading and understanding the Terms & Conditions, Privacy Policy, and this Refund & Cancellation Policy.</li>
          <li>Ensuring accurate details are provided during the transaction process.</li>
        </ul>

         {/* Section 12 - Contact Information */}
        <h5 style={{ color: "#111827", marginTop: "20px" }}>
          11. Contact Information
        </h5>
        <p style={{ color: "#4b5563", lineHeight: "1.8" }}>
          📍 Ahmedabad, India <br />
          📧 info.gpsfinvest@gmail.com <br />
          📞 +91 84600 28397
        </p>

        {/* <p
          style={{
            marginTop: '40px',
            color: '#9ca3af',
            fontStyle: 'italic',
            textAlign: 'right',
            fontSize: '0.9rem',
          }}
        >
          Last updated: September 25, 2025
        </p> */}
      </div>
    </div>
  );
}
